import React, { useEffect, useState, useRef } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { Chart } from "primereact/chart";
import CallLog from "../../AnalyticsComponent/CallLog";
import CallLogService from "../../Services/CallLogService";
import CheckInAndCheckOutService from "../../Services/CheckInAndCheckOutService";
import { formatDate, getIcons } from "../../Constant/Constant";
import { baseUrl } from "../../../config/clientsConfig";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { BiLeftArrow } from "react-icons/bi";
import { IoIosArrowBack } from "react-icons/io";
import {
  fetchIVRCallGraphData,
  fetchIVRCallLogData,
  fetchNormalCallGraphData,
  fetchNormalCallLogData,
} from "../../Services/AnalyticsService";
import CustomSelect from "../../common/CustomSelect";

import { getBasePathByUserRole } from "../../../utils/roleRoutes";
import { features } from "../../../config/featureConfig";
import { teamDetails, teamIds, userRole } from "../../../utils/storage";

const UserAnalyticsData = () => {
  const { state } = useLocation();

  const { userName, teamName, user, teamId, mdTeamId, memberList } =
    state || {};
  const initialDate = format(new Date(), "yyyy-MM-dd");
  const [selectedDate, setSelectedDate] = useState(initialDate);
  const [callLogHistory, setCallLogHistory] = useState([]);
  const [checkInAndCheckOut, setCheckInAndCheckOut] = useState([]);
  const [totalCallTime, setTotalCallTime] = useState(0);
  const icon = getIcons();

  const chartRef = useRef(null);
  const [chartData, setChartData] = useState({});
  const [chartCount, setChartCount] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const [selectedTime, setSelectedTime] = useState(null);
  const [callCount, setCallCount] = useState(0);
  const [callCounts, setCallCounts] = useState({});
  const [toggle, setToggle] = useState(false);
  const [range, setRange] = useState([null, null]);

  const [selectedTab, setSelectedTab] = useState("all");

  let selectedUser = {
    value: user?.userId || "",
    label: user?.name || "",
  };
  const [selectedMember, setSelectedMember] = useState(selectedUser || {});

  const navigate = useNavigate();

  console.log("Selected range:", range);
  // Fetch chart data
  useEffect(() => {
    if (!user || !selectedDate) return;

    const fetchChartData = async () => {
      // try {
      //   const response = await axios.get(
      //     `${baseUrl}/analytics/callLog-graph?docId=${userId}&startDate=${selectedDate}`
      //   );
      //   const callLogs = response.data.data;
      //   const labels = callLogs.map((log) => log.timeRange);
      //   const dataPoints = callLogs.map((log) => log.count);

      //   setChartData({
      //     labels: labels,
      //     datasets: [
      //       {
      //         data: dataPoints,
      //         fill: true,
      //         borderColor: "rgb(57, 158, 121)",
      //         tension: 0.4,
      //         backgroundColor: "rgba(57, 158, 121, 0.3)",
      //       },
      //     ],
      //   });
      // } catch (error) {
      //   console.error("Error fetching call log data:", error);
      // }
      try {
        const body = {
          userId: selectedMember.value,
          startDate: formatDate(selectedDate),
        };
        let response = {};

        if (toggle) {
          response = await fetchIVRCallGraphData(body);
        } else {
          response = await fetchNormalCallGraphData(body);
        }
        const rawData = response.data.data;
        setChartCount(response.data || []);

        // Transform for Chart.js
        const labels = rawData.map((item) => item.timeRange);
        const data = rawData.map((item) => item.count);

        setChartData({
          labels,
          datasets: [
            {
              label: "Call Count",
              data,
              fill: false,
              borderColor: "#399E79",
              tension: 0.4,
              pointBackgroundColor: "#399E79",
              backgroundColor: "rgba(57, 158, 121, 0.3)",
            },
          ],
          timeData: rawData,
        });
      } catch (error) {
        console.error("Error fetching call log data:", error);
        setChartData([]);
        setChartCount(null);
      }
    };

    fetchChartData();
  }, [selectedMember, selectedDate, toggle]);

  // Set chart options
  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--text-color");
    const textColorSecondary = documentStyle.getPropertyValue(
      "--text-color-secondary"
    );
    const surfaceBorder = documentStyle.getPropertyValue("--surface-border");

    setChartOptions({
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      responsive: true,
      plugins: {
        legend: {
          display: false,
        },
      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            display: false,
          },
        },
        y: {
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            display: false,
          },
        },
      },
      onClick: (e) => {
        const chartInstance = chartRef.current?.chart;
        if (!chartInstance) return;

        const points = chartInstance.getElementsAtEventForMode(
          e.native,
          "nearest",
          { intersect: true },
          true
        );

        if (points.length) {
          const { index } = points[0];
          const selected = chartData.timeData?.[index];
          if (selected) {
            setSelectedTime(selected.timeRange);
            setCallCount(selected.count);
          }
        }
      },
    });
  }, [chartData]);

  // Fetch call log history
  useEffect(() => {
    const fetchCallLog = async () => {
      // try {
      //   const response = await CallLogService.getCallLogHistory(
      //     userId,
      //     selectedDate
      //   );
      //   setCallLogHistory(response.data);
      //   const totalDuration = response.data.reduce(
      //     (acc, call) => acc + call.callDurationInSeconds,
      //     0
      //   );
      //   setTotalCallTime(totalDuration);
      // } catch (error) {
      //   setTotalCallTime(0);
      //   console.error("Error fetching call log:", error);
      // }
      try {
        const body = {
          userId: selectedMember.value,
          startDate: formatDate(selectedDate),
          callType: selectedTab,
        };
        let response = {};
        if (toggle) {
          response = await fetchIVRCallLogData(body);
          setCallLogHistory(response.data?.callLogs);
          
          setCallCounts(response.data?.callCounts || {});
        } else {
          response = await fetchNormalCallLogData(body);
          setCallLogHistory(response.data?.callLogs);
         
          setCallCounts(response.data?.callCounts || {});
        }

        //console.log("Call Log Data", response.data?.callLogs);
        console.log("response.data?.callCounts", response.data?.callCounts);
      } catch (error) {
        console.error("Error fetching call log:", error);
        setCallLogHistory([]);
      }
    };

    fetchCallLog();
  }, [selectedMember, selectedDate, toggle, selectedTab]);

  // Fetch check-in/check-out data
  useEffect(() => {
    const fetchCheckInOut = async () => {
      try {
        const response = await CheckInAndCheckOutService.getData(
          selectedMember.value,
          selectedDate
        );
        setCheckInAndCheckOut(response.data);
      } catch (error) {
        console.error("Error fetching check-in/out:", error);
        if (error.response?.status === 404) {
          setCheckInAndCheckOut([]);
        }
      }
    };

    fetchCheckInOut();
  }, [selectedMember, selectedDate]);

  const breakTimes =
    Array.isArray(checkInAndCheckOut) &&
    checkInAndCheckOut
      .filter((item) => item.type === 2)
      .sort((a, b) => a.timestamp.localeCompare(b.timestamp));

  const checkInTime =
    (Array.isArray(checkInAndCheckOut) &&
      checkInAndCheckOut.find((item) => item.type === 1)?.timestamp) ||
    "No Data";

  const checkOutTime =
    (Array.isArray(checkInAndCheckOut) &&
      checkInAndCheckOut.find((item) => item.type === 3)?.timestamp) ||
    "No Data";

  const formatCallTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${hours} H : ${minutes} Min`;
  };

  const convertToMinutes = (time) => {
    try {
      const [timePart, modifier] = time.split(" ");
      let [hours, minutes] = timePart.split(":").map(Number);
      if (modifier === "PM" && hours !== 12) hours += 12;
      if (modifier === "AM" && hours === 12) hours = 0;

      return hours * 60 + minutes;
    } catch (error) {
      console.error("Error converting time to minutes:", error);
      return 0;
    }
  };

  const calculateWorkingHours = (checkIn, checkOut) => {
    if (
      !checkIn ||
      !checkOut ||
      checkIn === "No Data" ||
      checkOut === "No Data"
    )
      return "0H : 0M";
    const checkInMinutes = convertToMinutes(checkIn);
    const checkOutMinutes = convertToMinutes(checkOut);
    const diffMinutes = checkOutMinutes - checkInMinutes;
    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;
    return `${hours}H : ${minutes}M`;
  };

  const calculateTotalBreakTime = (breakTimes) => {
    let totalBreakMinutes = 0;
    Array.isArray(breakTimes) &&
      breakTimes.forEach((breakTime) => {
        const breakStartMinutes = convertToMinutes(breakTime.timestamp);
        const breakEndMinutes = convertToMinutes(breakTime.breakTimestamp);
        if (breakEndMinutes == 0) {
          totalBreakMinutes += 0;
        } else {
          totalBreakMinutes += breakEndMinutes - breakStartMinutes;
        }
      });
    const hours = Math.floor(totalBreakMinutes / 60);
    const minutes = totalBreakMinutes % 60;
    return `${hours}H : ${minutes}M`;
  };

  const workingHours = calculateWorkingHours(checkInTime, checkOutTime);
  const totalBreakTime = calculateTotalBreakTime(breakTimes);

  const timeStringToMinutes = (timeStr) => {
    const match = timeStr.match(/(\d+)H\s*:\s*(\d+)M/);
    if (!match) return 0;
    const hours = parseInt(match[1], 10);
    const minutes = parseInt(match[2], 10);
    return hours * 60 + minutes;
  };

  const minutesToTimeString = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}H : ${minutes}M`;
  };

  const workingMinutes = timeStringToMinutes(workingHours);
  const breakMinutes = timeStringToMinutes(totalBreakTime);
  const netWorkingMinutes = workingMinutes - breakMinutes;
  const netWorkingTimeStr = minutesToTimeString(netWorkingMinutes);

  const path =getBasePathByUserRole()

  return (
    <>
      <AdminAppBar />
      <div className="p-6  rounded-lg pt-28 shadow-lg">
        <div className="flex justify-between bg-white rounded-[10px] p-5">
          <div className="flex justify-between">
            <div className="w-auto flex items-center gap-3">
              <div>
                <IoIosArrowBack
                  onClick={() => {
                    sessionStorage.setItem(
                      "activeTab",
                      JSON.stringify({
                        tab: "team",
                        teamId: teamId,
                        mdTeamId: mdTeamId,
                      })
                    );
                    navigate(-1);
                  }}
                  size={25}
                  className="text-gray-500 text-xl cursor-pointer"
                />
              </div>
              <div className="">
                <div className="flex  gap-2">
                  User Name:{" "}
                  <h6 className="font-semibold w-48 whitespace-nowrap truncate">
                    {selectedMember?.label || "N/A"}
                  </h6>
                </div>
                <div className="flex gap-2">
                  Team:{" "}
                  <h6 className="font-semibold w-48 whitespace-nowrap truncate">
                    {userRole === "BOD" ? teamDetails[0]?.name : teamName || "N/A"}
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <div className="flex gap-2">
         
          
           <div className="w-[200px]">
           <CustomSelect
              options={memberList}
              value={selectedMember}
              onChange={(member) => setSelectedMember(member)}
              isClearable={false}
            />
           </div>
            <div className="flex gap-2 border border-gray-400 rounded-lg p-2 w-auto">
              <div>Date:</div>
              <DatePicker
                selected={new Date(selectedDate)}
                className="focus:outline-none"
                onChange={(date) => {
                  const formattedDate = format(date, "yyyy-MM-dd");
                  setSelectedDate(formattedDate);
                }}
                maxDate={new Date()}
                dateFormat="dd/MM/yyyy"
              />
            </div>
           
            <button
        className="px-3 bg-customGreen text-white rounded-[10px]"
       onClick={
        ()=>{
          navigate(`${path}/call-logs-list`, {
            state: {
              userId: selectedMember.value,
              teamId : teamId,
              startDate: range[0] ? format(range[0], "yyyy-MM-dd") : null,
              endDate: range[1] ? format(range[1], "yyyy-MM-dd") : null,
              callType: toggle ? "ivr" : "normal",
            },
          });
        }
       }
      >
        Call logs Summary
      </button>
          </div>
        </div>
        <div className="bg-white rounded-[10px] mt-6 p-5">
          <div className="flex border border-gray-400 rounded-lg p-2 shadow-sm m-3">
            <div className="flex">
              <div className="border-r w-64 border-gray-400">
                <div className="flex gap-2">
                  <img src={icon.checkIn} alt="" />
                  <div>
                    <h4 className="text-base">Day Check In</h4>
                    <h6 className="text-sm">{checkInTime}</h6>
                  </div>
                </div>
                <div className="flex gap-2">
                  <img src={icon.checkOut} alt="" />
                  <div>
                    <h4 className="text-base">Day Check Out</h4>
                    <h6 className="text-sm">{checkOutTime}</h6>
                  </div>
                </div>
              </div>
              <div className="border-r w-64 border-gray-400">
                <div className="flex gap-2 px-2">
                  <img src={icon.breakTime} alt="" />
                  <div>
                    <h4 className="text-base">Break</h4>
                    {Array.isArray(breakTimes) && (
                      <div className="h-14 overflow-y-auto scrollbar-hidden">
                        {breakTimes.map((breakTime, index) => (
                          <div key={index} className="">
                            <h6 className="text-sm">
                              {breakTime.timestamp} - {breakTime.breakTimestamp}
                            </h6>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full px-4">
              <div className="flex gap-2">
                <img src={icon.activityProgress} alt="" />
                <h4 className="text-base">Other Activity Summary</h4>
              </div>
              <div className="grid grid-cols-3 gap-2 px-5">
                <div className="flex flex-col items-center">
                  <h1 className="text-xl">{workingHours}</h1>
                  <h6 className="text-sm whitespace-nowrap">Logged-In Hours</h6>
                </div>
                <div className="flex flex-col items-center">
                  <h1 className="text-xl">{netWorkingTimeStr}</h1>
                  <h6 className="text-sm whitespace-nowrap">Working Hours</h6>
                </div>
                <div className="flex flex-col items-center">
                  <h1 className="text-xl">{totalBreakTime}</h1>
                  <h6 className="text-sm">Break Hours</h6>
                </div>
              </div>
            </div>
          </div>

{features.ivrCalls && (
           <div className="flex justify-between items-center mt-4">
           <div className="relative bg-slate-200 p-1 w-full max-w-[380px] rounded-[10px] flex justify-between items-center overflow-hidden">
              <div
                className="absolute top-1 bottom-1 left-1 w-[180px] bg-white rounded-[10px] shadow-soft-all transition-transform duration-300"
                style={{
                  transform: toggle ? "translateX(190px)" : "translateX(0px)",
                }}
              ></div>
  
              <div
                className={`w-[170px] z-10 text-center cursor-pointer py-2 font-medium transition-all duration-300 ${
                  !toggle ? "text-customGreen" : "text-gray-700"
                }`}
                onClick={() => {
                  setToggle(!toggle);
                }}
              >
                Sim Calls
              </div>
  
              <div
                className={`w-[170px] z-10 text-center cursor-pointer py-2 font-medium transition-all duration-300 ${
                  toggle ? "text-customGreen" : "text-gray-700"
                }`}
                onClick={() => {
                  setToggle(!toggle);
                }}
              >
                IVR Calls
              </div>
            </div>
  
   </div>
)}

          <div className="grid grid-cols-2 gap-3">
            <div className="w-full mt-2 ">
              <div className="mt-3 mb-6">
                <div className="flex items-center justify-between gap-3">
                  <div>
                    <h4 className="text-lg font-medium">Day Call Frequency</h4>
                    <div className="flex items-center justify-start gap-8 mt-2">
                      <div className="flex flex-col items-center">
                        <h1 className="text-xl font-semibold">
                          {chartCount?.overAllCallCount || 0}
                        </h1>
                        <h6 className="text-sm text-gray-600">Total Calls</h6>
                      </div>
                      
                      <div className="flex flex-col items-center">
                        <h1 className="text-xl font-semibold">
                          {chartCount?.dialedCallCount || 0}
                        </h1>
                        <h6 className="text-sm text-gray-700">
                          Total RNR calls
                        </h6>
                      </div>
                      <div className="flex flex-col items-center">
                        <h1 className="text-xl font-semibold">
                          {chartCount?.duration || "N/A"}
                        </h1>
                        <h6 className="text-sm text-gray-700">
                          Total Call Time
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Chart
                ref={chartRef}
                type="line"
                data={chartData}
                options={chartOptions}
                style={{ height: "300px", width: "100%" }}
              />

              {selectedTime && (
                <div className="mt-2">
                  <p className="text-xl">Selected Time: {selectedTime}</p>
                  <p className="text-lg">Call Count: {callCount}</p>
                </div>
              )}
            </div>
            <div className="mt-2">
              <CallLog
                callLogHistory={callLogHistory}
                callCountsData={callCounts}
                toggle={toggle}
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserAnalyticsData;
